var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedemption1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.6892 2.04134L6.03725 5.88529C5.14733 6.28082 4.56641 7.17074 4.56641 8.14718V13.9564C4.56641 20.8162 9.31265 27.231 15.6904 28.7884C22.0682 27.231 26.8144 20.8162 26.8144 13.9564V8.14718C26.8144 7.17074 26.2335 6.28082 25.3436 5.88529L16.6916 2.04134C16.0612 1.75705 15.3196 1.75705 14.6892 2.04134ZM15.6904 15.18H24.3424C23.6873 20.2723 20.2883 24.8085 15.6904 26.2299V15.1924H7.03841V8.14718L15.6904 4.30322V15.18Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedemption1);
export default __webpack_public_path__ + "static/media/redemption1.204bfc6d950d6d8d51f0d6ed2300aa9e.svg";
export { ForwardRef as ReactComponent };